import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_UNREAD_NOTIFICATIONS',
  'GET_READ_NOTIFICATIONS',
  'GET_NOTIFICATION_UNREAD_COUNT',
  'READ_NOTIFICATION',
  'DELETE_NOTIFICATION'
);
